function reverseCountdown(reverseCountdownItem, endNumber) {
    const intervalTime = 16; // Update interval in milliseconds
    const totalRuntime = 1000; // Total runtime in milliseconds
    const steps = Math.ceil(totalRuntime / intervalTime);
    const stepSize = endNumber / steps;
    let currentNumber = 0;

    const interval = setInterval(() => {
        if (currentNumber < endNumber) {
            currentNumber += stepSize;
            currentNumber = Math.round(currentNumber); // Round to the nearest whole number
            const formattedNumber = currentNumber.toLocaleString(); // Format with commas
            if (currentNumber >= endNumber) {
                reverseCountdownItem.innerHTML = parseInt(endNumber, 10).toLocaleString();
            } else {
                reverseCountdownItem.innerHTML = formattedNumber;
            }
        } else {
            clearInterval(interval);
        }
    }, intervalTime);
}

function startReverseCountdownWhenFullyVisible(reverseCountdownItem) {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && entries[0].intersectionRatio === 1) {
            setTimeout(function () {
                reverseCountdown(reverseCountdownItem, reverseCountdownItem.dataset.countdownReverse);
            }, 150);
            observer.unobserve(reverseCountdownItem);
        }
    }, { threshold: 1 });

    observer.observe(reverseCountdownItem);
}

window.addEventListener('load', () => {
    const reverseCountdownItems = document.querySelectorAll("[data-countdown-reverse]");

    for (let reverseCountdownItem of reverseCountdownItems) {
        startReverseCountdownWhenFullyVisible(reverseCountdownItem);
    }
});